// IndexedDB storage utilities
export function createStore(_name: string) {
  return {
    async get(_key: string) {
      return null;
    },
    async set(_key: string, _value: any) {
      // Stub implementation
    },
    async delete(_key: string) {
      // Stub implementation
    },
  };
}

